import { render, staticRenderFns } from "./KpiBar.vue?vue&type=template&id=72acdbb5&scoped=true&"
import script from "./KpiBar.vue?vue&type=script&lang=js&"
export * from "./KpiBar.vue?vue&type=script&lang=js&"
import style0 from "./KpiBar.vue?vue&type=style&index=0&id=72acdbb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72acdbb5",
  null
  
)

export default component.exports